import type {DataRouterEditBlobPagePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewNewRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewNewRoute', {
  path: '/:owner/:repo/new/:branch/*',
  queries: [
    mainQuery<DataRouterEditBlobPagePayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: Object.fromEntries(searchParams)}),
      encodeFetchPath: true,
    }),
  ],
})
